import { combineReducers } from "@reduxjs/toolkit";
import common from "./common.slice";
import master from "./master.slice";
import pos from "./pos.slice";
import member from "./member.slice";
import entity from "./entity.slice";
import branchProduct from "./branchProduct.slice";
import table from "./table.slice";
import bill from "./bill.slice";
import kitchen from "./kitchen.slice";
import payment from "./payment.slice";
const appReducer = combineReducers({
  common,
  master,
  pos,
  member,
  entity,
  branchProduct,
  table,
  bill,
  kitchen,
  payment,
});

const rootReducer = (state, action) => {
  if (action.type === "RESET_STATE") {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
